import PropTypes from 'prop-types'
import { createContext, useState, useEffect } from 'react'
import { Space, Spin, Button, notification, message, Popconfirm, Radio, Flex, DatePicker, Image, Upload } from 'antd';
import {
	RadiusBottomleftOutlined,
	RadiusBottomrightOutlined,
	RadiusUpleftOutlined,
	RadiusUprightOutlined,
	LoadingOutlined,
	InboxOutlined, 
	QuestionCircleOutlined
} from '@ant-design/icons';
export const SiteContext = createContext();


export const SiteProvider = ({ children }) => {

	const base_api_url	= 'http://localhost/diamta/projects/public/api/'; 
	// const base_api_url		= 'https://diamta.com/projects/public/index.php/api/'

	// spiner
	const [ spiner, setSpiner ] = useState( 'none' );

	// helper: Fetch data definition
	async function fetchData( url, data, method, spiner ) {
		if( !isOnline ){
			message.error( 'No network!' );
			return false;
		}
		
		if( spiner )
			setSpiner( 'block' )

		const response = await fetch( url, {
			method: method, // *GET, POST, PUT, DELETE, etc.
			// mode: "no-cors", // no-cors, *cors, same-origin
			headers: {
				"Content-Type": "application/json",
				// 'Content-Type': 'application/x-www-form-urlencoded',
			},
			...( method == 'POST' && { body: JSON.stringify( data ), } )
		});
		setTimeout( setSpiner, 2000, 'none' );
		
		if( response.status != 200 )
			return false;
		
		if( response.status == 200 ){
			return response.json(); // parses JSON response into native JavaScript objects
			// if( method == 'GET' )
				// return response.json(); // parses JSON response into native JavaScript objects
			
			// if( method == 'POST' )
				// return true;

		}
	}
	
	// Backend url
	// const siteURL = 'http://localhost/diamta/projects/public/'; // dev
	const siteURL = 'https://diamta.com/projects/public/';	// prod
	
	
	// contact to invite
	const [ contact, setContact ] = useState( {} );


	// save user password
	const passwordSave = async ( data ) => {
		const url 		= base_api_url +  'password/save';
		const method 	= 'POST';
		const resp 		= await fetchData( url, data, method );

		return resp;
	}

	// save user profile
	const getCurrentPassword = async ( userId ) => {
		const url 		= base_api_url + 'password/get/?userId=' + userId;
		const method 	= 'GET';
		const data 		= {};
		const resp 		= await fetchData( url, data, method );
		return resp;
	}

	// password forgot
	const passwordForgot = async ( data ) => {
		const url 		= base_api_url + 'password/forgot/?email=' + data.email + '&code= ' + data.code;
		const method 	= 'GET';
		const resp 		= await fetchData( url, data, method );

		return resp;
	}

	// password update
	const passwordUpdate =  async ( userId, password ) => {

		const url 		= base_api_url + 'password/update/?userId=' + userId + '&password=' + password;
		const method 	= 'GET';
		const data 		= {};
		const resp 		= await fetchData( url, data, method );
		return resp;
	}
	// password update
	const passwordCheck =  async ( userId, password ) => {

		const url 		= base_api_url + 'password/check/?userId=' + userId + '&password=' + password;
		const method 	= 'GET';
		const data 		= {};
		const spiner	= false;
		const resp 		= await fetchData( url, data, method, spiner );
		return resp;
	}	


	// Network state
	const [ isOnline, setIsOnline ] = useState( navigator.onLine );

	// Tab state
	const [ isTabReactivated, setIsTabReactivated ] = useState( false ); 

	// Is tab active
	const [ isTabActive, setIsTabActive ] = useState( true ); 


	const favicon = 'img/favicon.png';
	
	// site
	const [ site, setSite ] = useState( {} );

	// set user referrer before redirection to login page
	const setReferrer = ( url ) => {
		site[ 'referrer' ] = url;
	}
	
	// get user referrer
	const getReferrer = () => {

		return site.referrer;
	}
	
	return (

		<SiteContext.Provider 
			value={{ 
				setReferrer,
				getReferrer,
				siteURL,
				passwordSave,
				getCurrentPassword,
				passwordForgot,
				passwordUpdate,
				passwordCheck
			}}
		>
		
			<Space
				style={{ display: spiner }}
			>
				<Spin
					indicator={
						<LoadingOutlined
							style={{
									display:		spiner,
									fontSize: 		100,
									color: 			'#fcb800'
								}}
							spin
						/>
					}
					fullscreen
					tip		= "loading" 
					size	= "large"
			/>
			
		</Space>

		{children}

		</SiteContext.Provider>

	);

};

SiteProvider.propTypes = {
	children: PropTypes.node.isRequired,
};